import React from 'react';

import { Typography } from '@mui/material';
import { NoAvailableMessage } from 'app/shared/components/common/NoAvailableMessage';

import { getDateTimeFormat } from '../Underwriting.utils';

import { emptyMessageCellStyles } from './KeyDates.styles';

export const keyDatesConfig = {
  tridApplicationDate: {
    label: 'Trid Application Date',
    width: '25%',
    content: ({ tridApplicationDate }) =>
      tridApplicationDate?.content ?? (
        <Typography data-truncated className="truncate" variant="regular14">
          {getDateTimeFormat(tridApplicationDate)}
        </Typography>
      ),
    colSpan: ({ tridApplicationDate }) => tridApplicationDate?.colSpan,
    customStyles: ({ tridApplicationDate }) => tridApplicationDate?.customStyles,
  },
  ecoaDate: {
    label: 'ECOA Date',
    width: '25%',
    content: ({ ecoaDate }) => (
      <Typography data-truncated className="truncate" variant="regular14">
        {getDateTimeFormat(ecoaDate)}
      </Typography>
    ),
  },
  mcrApplicationDate: {
    label: 'MCR Application Date',
    width: '25%',
    content: ({ mcrApplicationDate }) => (
      <Typography data-truncated className="truncate" variant="regular14">
        {getDateTimeFormat(mcrApplicationDate)}
      </Typography>
    ),
  },
  loanApplicationDate: {
    label: 'Loan Application Date',
    width: '25%',
    content: ({ loanApplicationDate }) => (
      <Typography data-truncated className="truncate" variant="regular14">
        {getDateTimeFormat(loanApplicationDate)}
      </Typography>
    ),
  },
};

export const keyDatesNotFoundTableData = [
  {
    tridApplicationDate: {
      position: 1,
      customStyles: emptyMessageCellStyles,
      colSpan: 4,
      content: <NoAvailableMessage className="empty-message-row" message="No Data" />,
    },
  },
];
